import { AbstractProper, setProperSymbols } from '../../types/lux'
import { deriveValues } from './derive'
import { safeAssign } from './lib'
import { DeriverSeer } from './Seer'

export default AbstractProper

/** @constructor @extends {AbstractProper} @suppress {checkTypes} */ function _AbstractProper() {}
AbstractProper.__implement(
  _AbstractProper.prototype = /** @type {!AbstractProper} */ ({
    initialiser({ props }) {
      setProperSymbols(this, {
        _props: props,
        _initialProps: props,
      })
      return this
    },
    setProps(newProps) {
      let { asIProper: { props } } = this
      if (!props) { // an edge case if the stateful __$constructor wasn't called yet
        props = {}
        setProperSymbols(this, {
          _props: props,
        })
      }
      const { allSame } = safeAssign(newProps, props)
      return { allSame }
    },
    set props(props) {
      const{asIProper:{setProps}}=this
      setProps(props)
    },
    setDerivedProps(derivedProps,instance) {
      const{asIProper:{setProps}}=this
      const seer=new DeriverSeer()
      seer.cb=setProps
      seer.derivedProps=derivedProps
      seer.instance=instance||null
      const propsValues=deriveValues(derivedProps,instance,null,seer)
      setProps(propsValues)
    },
  }),
)